export const LOGIN = 'app/LoginPage/LOGIN';
export const LOGIN_SUCCESS = 'app/LoginPage/LOGIN_SUCCESS';
export const LOGIN_FAILED = 'app/LoginPage/LOGIN_FAILED';

export const RESET_LOGIN = 'app/LoginPage/RESET_LOGIN';

export const LOGOUT = 'app/LoginPage/LOGOUT';
export const LOGOUT_SUCCESS = 'app/LoginPage/LOGOUT_SUCCESS';
export const LOGOUT_FAILED = 'app/LoginPage/LOGOUT_FAILED';
